"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemandData = void 0;
const responses_1 = require("../../sales-order/responses");
const enums_1 = require("../enums");
class DemandData {
}
exports.DemandData = DemandData;
//# sourceMappingURL=demand-data.response.js.map